import { useMemo } from 'react';
import { NumberFormatter } from '../../../Components/NumberFormatter/NumberFormatter';
import { BPMTable } from '../../../Components/StickyTable/BPMTable';

interface FeatureMappingSpendSummaryProps {
  data: Record<string, { pctSpend: number; spend: number }>;
}

export const FeatureMappingSpendSummary = ({ data }: FeatureMappingSpendSummaryProps) => {
  const formattedData = useMemo(
    () =>
      Object.entries(data)
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([featureName, { pctSpend, spend }]) => ({
          featureName,
          spendPercentage: pctSpend,
          spend
        })),
    [data]
  );

  const headers = [
    { label: 'Feature Name', name: 'featureName', flex: 2 },
    {
      label: 'Spend',
      name: 'spend',
      flex: 1,
      renderer: row => <NumberFormatter value={row.spend} type='$' />
    },
    {
      label: 'Spend %',
      name: 'spendPercentage',
      flex: 1,
      renderer: row => <NumberFormatter value={row.spendPercentage} type='%' decimals={2} />
    }
  ];

  return (
    <div className='feature-mapping-spend-summary' data-testid='spend-summary'>
      <BPMTable data={formattedData} headers={headers} filterBar={false} />
    </div>
  );
};
